<template>
  <v-card
    max-width="350"
    class="mx-auto mt-6 quadro"
    @click="$emit('click', this)"
  >
    <v-list-item>
      <v-list-item-avatar color="grey"
        ><img :src="value.AuthorImg" :alt="value.Author" />
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title class="headline quadro2">
          <p :title="value.Title">{{ value.Title.slice(0, 20) }}</p>
        </v-list-item-title>
        <v-list-item-subtitle>por {{ value.Author }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-card-text class="quadro2">{{ value.Summary }}</v-card-text>

    <v-card-actions class="align-self-end">
      <v-btn text>Continuar a leitura</v-btn>
      <v-spacer></v-spacer>
      <v-btn icon>
        <v-icon>mdi-share-variant</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
export default {
  name: "uBlogPost",
  props: ["value", "ClassAd", "active", "dark"],
  components: {},
  created() {
    console.log("value", this.post);
  }
};
</script>

<style scoped>
.quadro {
  opacity: 0.9;
  filter: alpha(opacity=90); /* For IE8 and earlier */
  text-decoration-color: white;
}

.quadro2 {
  opacity: 1;
  filter: alpha(opacity=100); /* For IE8 and earlier */
  text-decoration-color: white;
}
</style>
